import { apiSlice } from "../../../api/apiSlice"
import { AuthResponse } from "./authType";

const toFormData = (data: Record<string, string>) => {
    return Object.keys(data)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
      .join('&');
  };

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      login: builder.mutation<AuthResponse, { email: string; password: string }>({
        query: ({ email, password }) => {
          const body = toFormData({
            grant_type: '',  // Add required params here
            username: email,
            password: password,
            scope: '',
            client_id: '',
            client_secret: '',
          });
  
          return {
            url: '/auth/login', 
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded', 
            },
            body, 
          };
        },
      }),
    }),
  });

export const {
    useLoginMutation
} = authApiSlice